import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobFlowPage from '@/features/jobs/job-flow/JobFlowPage';

export const jobFlowRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/fluxo',
  component: JobFlowPage,
});
